export enum MessageFrom {
  AI = 'AI',
  USER = 'USER',
}

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER',
}
